import { Heading, Text } from '@wix/design-system'
import { useContent } from '@wix/funnel-builder-lizard'
import { ArrowRight } from '@wix/wix-ui-icons-common'
import React, { FC, useEffect } from 'react'
import { v4 as randomUUID } from 'uuid'

import { usePageLogger } from '../../../bi/mfi'
import { useNext } from '../../../hooks/useNext'
import { EnterpriseLayout } from '../EnterpriseLayout'
import { TEnterpriseFormWelcome as Content } from './EnterpriseFormWelcome.content'
import s from './EnterpriseFormWelcome.scss'

export const EnterpriseFormWelcome: FC = () => {
  const page = useContent<Content>()
  const next = useNext()
  const pageLogger = usePageLogger()
  const { questionKey, content, options } = page.content.question

  useEffect(() => {
    pageLogger.screenView()
  }, [pageLogger])

  const handleNext = (optionKey: string) => {
    const submissionId = randomUUID()

    next({ [questionKey]: { values: [optionKey] } }, { submissionId })
    pageLogger.answer({ answer: optionKey, questionName: questionKey, additionalInfo: submissionId })
  }

  return (
    <EnterpriseLayout>
      <div className={s.wrapper}>
        <div className={s.titles}>
          <Heading className={s.title}>{content.title}</Heading>
          <Heading className={s.subtitle}>{content.subtitle}</Heading>
        </div>
        <div className={s.options}>
          {options.map(option => (
            <button key={option.optionKey} onClick={() => handleNext(option.optionKey)} className={s.option}>
              <Text className={s.optionTitle}>{option.title}</Text>
              <div className={s.arrow}>
                <ArrowRight />
              </div>
            </button>
          ))}
        </div>
      </div>
    </EnterpriseLayout>
  )
}
